import { css } from '@/styled-system/css';

export const accordionRootStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  gap: 'Accordion.gap.betweenAccordions',
});
